<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import ExcelImport from "@/components/ExcelImport.vue";
import ExcelExport from "@/components/ExcelExport.vue";
import DataTable from "@/components/DataTable.vue";

export default {
  page: {
    title: "Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelImport,
    ExcelExport,
    DataTable,
  },
  data() {
    return {
      title: "Sales Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Report",
          active: true,
        },
      ],

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsSalesServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      editAmtData: {
        id: "",
        total: "",
        paid: "",
      },
      deleteData: {
        id: "",
        filterdata: {},
      },
      editData: {
        id: "",
        filterdata: {},
      },

      submitData: {
        id: "",
        filterdata: {},
      },

      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        customer: "",
        branch_id: 0,
        receipt: "",
        app: "",
        product: "",
        delivery_mode: "",
        staff: "",
        status: "",
        page: 1,
        per_page: 50,
      },

      invoice: {
        id: "",
      },
      id: "",
      amountError: "",
      is_uploading: false,
      excelTemplateFields: {
        Date: "Date",
        "Customer Name": "Customer Name",
        "Customer Contact": "Customer Contact",
        Total: "Total",
        Paid: "Paid",
        Discount: "Discount",
        "Product Name": "Product Name",
        Category: "Category",
        Unit: "Unit",
        "Product Code": "Product Code",
        "Minimum Quantity": "Minimum Quantity",
        "Quantity Sold": "Quantity Sold",
        "Cost Price": "Cost Price",
        "Retail Price": "Retail Price",
        "Wholesale Price": "Wholesale Price",
      },
      excelRequiredHeaders: ["Date", "Product Name"],
      salesColumns: [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) => this.SalesPagination.from + idx,
        },
        {
          key: "sync",
          label: "STATUS",
          formatter: (_, row) => (row.fdn ? "Synchronized" : "Unsynchronized"),
        },
        { key: "product", label: "PRODUCT" },
        {
          key: "qty",
          label: "QTY",
          formatter: (_, row) =>
            row.items?.map((i) => i.qty + i.usymbol).join(", "),
        },
        { key: "price", label: "PRICE" },
        { key: "total_price", label: "TOTAL PRICE" },
        {
          key: "product_code",
          label: "CODES(S)",
          formatter: (_, row) =>
            this.GeneralSettings.allow_multiple_productcodes
              ? row.items
                ?.map((i) => i.allow_multiple_productcodes || "")
                .join(", ")
              : "",
        },

        {
          key: "description",
          label: "DESC",
          formatter: (_, row) =>
            this.GeneralSettings.sale_description
              ? row.items?.map((i) => i.description || "").join(", ")
              : "",
        },
        {
          key: "batch",
          label: "BATCH",
          formatter: (_, row) =>
            this.GeneralSettings.track_expiries
              ? row.items?.map((i) => i.batch || "").join(", ")
              : "",
        },

        { key: "totalAmt", label: "TOTAL" },
        {
          key: "totalPaid",
          label: "PAID",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "discount",
          label: "DISCOUNT",
          formatter: (v) => this.thousandSeperator(v),
        },

        {
          key: "customerobj",
          label: "CUSTOMER",
          formatter: (_, row) => row.customerobj?.name ?? "N/A",
        },
        { key: "user", label: "USER" },
        { key: "date", label: "DATE" },
        { key: "addedon", label: "RECORDED ON" },
        { key: "receipt", label: "RECEIPT" },
        { key: "actions", label: "ACTIONS", tdClass: "text-nowrap" },
      ],
      expandedDescriptions: {},
    };
  },
  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("saledetails", [
      "SaveStatus",
      "filterStatus",
      "SalesData",
      "SalesPagination",
      "SalesSummary",
      "SalesPaginated",
    ]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),
    ...mapGetters("setting", ["GeneralSettings", "ReceiptSettings"]),
    ...mapGetters("invoices", ["InvoiceId"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("staff", ["DeliveryStaff"]),

    rows() {
      return this.IsSalesServerPaginated
        ? this.SalesPagination?.total
        : this.SalesData
          ? this.SalesData.length
          : 0;
    },

    perPage: {
      get() {
        if (this.IsSalesServerPaginated) {
          return (
            (this.SalesPagination && this.SalesPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsSalesServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchSales(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.SalesPaginated && this.SalesPagination
          ? this.SalesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.SalesPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.SalesSummary || {
          totalAmount: 0,
          totalPaid: 0,
          totalDiscount: 0,
          totalBalance: 0,
        }
      );
    },
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    InvoiceId(newValue) {
      if (newValue && this.ReceiptSettings.invoice_type == 1) {
        window.open(
          `https://${window.location.host}/receipts/invoice.php?id=${btoa(
            newValue
          )}`
        );
      } else if (newValue && this.ReceiptSettings.invoice_type == 2) {
        this.$router.push(`/invoice_details/${btoa(newValue)}`);
      }
    },
  },
  methods: {
    ...mapActions({
      FetchSales: "saledetails/fetchSalesData",
      EditPaid: "saledetails/editAmtPaidMode",
      EditSale: "saledetails/editSale",
      DeleteSale: "saledetails/deleteSale",
      FetchCustomers: "customers/fetchCustomers",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      GenerateNewInvoice: "invoices/generateInvoice",
      FetchProducts: "products/fetchProducts",
      FetchStaff: "staff/fetchStaff",
      SubmitSale: "saledetails/submitSale",
    }),

    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    resetModal() {
      this.editAmtData.id = "";
      this.editAmtData.total = "";
      this.editAmtData.paid = "";
      this.id = "";
    },
    resetError() {
      this.amountError = "";
    },
    resetDelete() {
      this.deleteData.id = "";
    },
    resetEdit() {
      this.editData.id = "";
    },
    resetGenerate() {
      this.invoice.id = "";
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
      this.editData.filterdata = this.data;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
      this.deleteData.filterdata = this.data;
    },
    addCommas() {
      this.editAmtData.paid = this.thousandSeperator(this.editAmtData.paid);
    },
    ShowEdit(data) {
      this.editAmtData.id = data.id;
      this.editAmtData.total = data.totalAmt;
      this.editAmtData.paid = this.thousandSeperator(data.totalPaid);
    },
    showInvoiceModal(data) {
      this.invoice.id = data.item.id;
    },
    editAmt(modalId) {
      this.modal_id = modalId;
      if (this.editAmtData.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      this.editAmtData.filterdata = this.data;
      this.EditPaid(this.editAmtData);
    },
    editSale(modalId) {
      this.modal_id = modalId;
      this.EditSale(this.editData);
    },
    deleteSale(modalId) {
      this.modal_id = modalId;
      this.DeleteSale(this.deleteData);
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    filterReport() {
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.IsSalesServerPaginated
        ? this.perPage
        : this.serverPerPage;

      this.FetchSales(payload);
    },

    handlePageChange(newPage) {
      if (this.IsSalesServerPaginated) {
        this.data.page = newPage;
        this.FetchSales(this.data);
      }
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting the sales data. Please try again.",
        confirmButtonText: "OK",
      });
    },

    Receipt_print(Id) {
      if (this.ReceiptSettings.receipt_type == 1) {
        window.open(
          `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(
            Id
          )}`
        );
      } else if (this.ReceiptSettings.receipt_type == 2) {
        window.open(
          `https://${window.location.host
          }/receipts/salesreceiptv2.php?id=${btoa(Id)}`
        );
      } else if (this.ReceiptSettings.receipt_type == 3) {
        window.open(
          `https://${window.location.host
          }/receipts/salesreceiptv3.php?id=${btoa(Id)}`
        );
      } else if (this.ReceiptSettings.receipt_type == 4) {
        window.open(
          `https://${window.location.host
          }/receipts/salesreceiptv4.php?id=${btoa(Id)}`
        );
      } else if (this.ReceiptSettings.receipt_type == 5) {
        window.open(
          `https://${window.location.host}/receipts/deliverynote.php?id=${btoa(
            Id
          )}`
        );
      } else if (this.ReceiptSettings.receipt_type == 6) {
        window.open(
          `https://${window.location.host
          }/receipts/salesreceiptv6.php?id=${btoa(Id)}`
        );
      } else {
        window.open(
          `https://${window.location.host}/receipts/receipt.php?id=${btoa(Id)}`
        );
      }
    },

    GenerateInvoice(modal) {
      this.GenerateNewInvoice(this.invoice.id);
      this.closeModal(modal);
    },

    // Excel import event handlers
    handleExcelImportSuccess(result) {
      Swal.fire(
        "Success!",
        result.message || "Sales imported successfully!",
        "success"
      );
      this.FetchSales(this.data);
      this.closeModal("import-sales-modal");
    },

    handleExcelImportError() {
      Swal.fire(
        "Error!",
        "There was an error while importing the sales. Please try again",
        "error"
      );
    },

    // Custom validation for Excel import
    validateSalesData(data) {
      const errors = [];
      data.forEach((row, index) => {
        const rowNum = index + 2;

        // Validate Date format
        if (row.Date && String(row.Date).trim() !== "") {
          const date = new Date(row.Date);
          if (isNaN(date.getTime())) {
            errors.push(`Row ${rowNum}: Date must be a valid date format`);
          }
        }

        // Validate Customer Contact (if provided)
        if (
          row["Customer Contact"] &&
          String(row["Customer Contact"]).trim() !== ""
        ) {
          const contact = String(row["Customer Contact"]).trim();

          // Check if it's a valid integer (only digits)
          if (!/^\d+$/.test(contact)) {
            errors.push(
              `Row ${rowNum}: Customer Contact must be a valid number (integers only)`
            );
          }
          // Check length (max 11 digits)
          else if (contact.length > 11) {
            errors.push(
              `Row ${rowNum}: Customer Contact should not exceed 11 digits`
            );
          }
        }

        // Validate numeric fields if they exist
        const numericFields = [
          "Total",
          "Paid",
          "Discount",
          "Quantity Sold",
          "Cost Price",
          "Retail Price",
          "Wholesale Price",
          "Minimum Quantity",
        ];
        numericFields.forEach((field) => {
          if (
            row[field] !== null &&
            row[field] !== undefined &&
            row[field] !== ""
          ) {
            const value = Number(row[field]);
            if (Number.isNaN(value) || value < 0) {
              errors.push(
                `Row ${rowNum}: ${field} must be a valid non-negative number`
              );
            }
          }
        });
      });

      return errors;
    },

    setID(id) {
      this.id = id;
    },

    showReceipt(id) {
      this.$router.push(`/sales/viewsale/${btoa(id)}`);
      this.id = "";
    },

    showDeliverynote(id) {
      this.$router.push(`/printdeliverynote/${btoa(id)}`);
      this.id = "";
    },
    showSubmitModal(data) {
      this.submitData.id = data.id;
    },
    submitSale(modalId) {
      this.submitData.filterdata = this.data;
      this.modal_id = modalId;
      this.SubmitSale(this.submitData);
    },
    truncate(text, length) {
      if (!text) return "";
      if (text.length <= length) return text;
      return text.substring(0, length) + "...more";
    },
    toggleDescription(rowIdx) {
      this.$set(
        this.expandedDescriptions,
        rowIdx,
        !this.expandedDescriptions[rowIdx]
      );
    },
  },
  created() {
    this.FetchSales(this.data);
    this.FetchGeneralSettings();
    this.FetchCustomers();
    this.FetchBranches();
    this.fetchReceiptSettings();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">
        {{ business }}
      </h4>
      <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
        <em v-if="
          GeneralSettings.show_branchname == 1 &&
          GeneralSettings.show_businessname == 1
        ">-</em>
        {{ branch }}
      </h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-3 mb-3">
                <div v-if="
                  GeneralSettings.import_sales == 1 &&
                  branchid != 0
                ">
                  <b-button v-b-modal.import-sales-modal variant="info"><i class="fa fa-plus"></i> Import Sales
                  </b-button>
                </div>
              </div>
              <div class="col-2">
                <ExcelExport endpoint="export_basicsales" filename="sales_report.xlsx" :payload="data"
                  button-text="Export" button-variant="info" icon-class="fas fa-download"
                  @export-error="handleExportError" />
              </div>
              <div class="col-4">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>
              <div class="col-md-3 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches
                  ? [{ id: 0, name: 'All Branches' }, ...Branches]
                  : []
                  " v-model="data.branch_id" option-value="id" option-text="name" placeholder="Select Branch"
                  @input="filterReport()">
                </model-list-select>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-3">
                <label>FILTER BY PRODUCT</label>
                <model-list-select :list="Products
                  ? [{ id: '', name: 'All Products' }, ...Products]
                  : []
                  " v-model="data.product" option-value="id" option-text="name" placeholder="Select Product"
                  @input="filterReport()">
                </model-list-select>
              </div>
              <div class="col-md-3">
                <label>FILTER BY STATUS</label>
                <select v-model="data.status" @change="filterReport()" class="form-control">
                  <option value="">All statuses</option>
                  <option value="1">Synchronized</option>
                  <option value="2">Unsynchronized</option>
                </select>
              </div>
              <div class="col-2">
                <label>FILTER BY APPS</label>
                <select v-model="data.app" @change="filterReport()" class="form-control">
                  <option value="">All Apps</option>
                  <option value="0">Web</option>
                  <option value="2">Desktop App</option>
                  <option value="1">Mobile App</option>
                </select>
              </div>
              <div class="col-2" v-if="GeneralSettings.capture_delivery_staff">
                <label>FILTER BY DELIVERY MODE</label>
                <select v-model="data.delivery_mode" @change="filterReport()" class="form-control">
                  <option value="">All Modes</option>
                  <option value="1">Delivered</option>
                  <option value="2">Not Delivered</option>
                </select>
              </div>
              <div class="col-2" v-if="GeneralSettings.capture_delivery_staff">
                <label>FILTER BY STAFF</label>
                <model-list-select :list="DeliveryStaff
                  ? [{ id: '', name: 'All Staff' }, ...DeliveryStaff]
                  : []
                  " v-model="data.staff" option-value="id" option-text="name" placeholder="Select Staff"
                  @input="filterReport()">
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="data.datefrom" class="form-control" v-limit-future-date/>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="data.dateto" class="form-control" v-limit-future-date/>
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>CUSTOMERS</label>
                <model-list-select :list="Customers
                  ? [{ id: '', name: 'All Customers' }, ...Customers]
                  : []
                  " v-model="data.customer" option-value="id" option-text="name" placeholder="Select Customer"
                  @input="filterReport()">
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>RECEIPT NO.</label>

                <input class="form-control" v-model="data.receipt" placeholder="Enter Receip No"
                  @keyup.enter="filterReport()" />
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <router-link :to="'/advanced_reports/salesanalysis_report'">
                  <b-button variant="info">Return Sales</b-button>
                </router-link>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable :columns="salesColumns" :rows="SalesData" :total-rows="rows" :pagination="SalesPagination"
                :server-pagination="IsSalesServerPaginated" :loading="filterStatus" row-class="sales-table-bordered">
                <template #cell(sn)="{ index }">
                  <span class="purchase-row-end">
                    {{ SalesPagination.from + index }}
                  </span>
                </template>

                <template #cell(sync)="{ row }">
                  <div class="purchase-row-end">
                    <button class="btn btn-info btn-sm" v-b-modal.sale-submit-modal @click="showSubmitModal(row)"
                      v-if="MyUserPerm.edit_sales == 1 && !row.fdn">
                      Synchronize
                    </button>

                    <button class="btn btn-sm" disabled v-if="MyUserPerm.edit_sales == 1 && row.fdn">
                      <h6>Synchronized</h6>
                    </button>
                  </div>
                </template>

                <template #cell(product)="{ row }">
                  <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                    {{ i.product }}
                  </div>
                </template>

                <template #cell(qty)="{ row }">
                  <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                    {{ i.qty + i.usymbol }}
                  </div>
                </template>

                <template #cell(price)="{ row }">
                  <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                    {{ i.SPrice ? thousandSeperator(i.SPrice) : 0 }}
                  </div>
                </template>

                <template #cell(total_price)="{ row }">
                  <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                    {{ i.total_price ? thousandSeperator(i.total_price) : 0 }}
                  </div>
                </template>
                <template #cell(product_code)="{ row }">
                  <div v-if="GeneralSettings.allow_multiple_productcodes">
                    <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                      {{ i.product_code }}
                    </div>
                  </div>
                </template>

                <template #cell(description)="{ row }">
                  <div v-if="GeneralSettings.sale_description == 1">
                    <div v-for="(i, idx) in row.items" :key="`${row.id}-${idx}`" class="mb-2">
                      <template v-if="expandedDescriptions[row.id + '-' + idx]">
                        <span class="desc-expanded" @click="toggleDescription(row.id + '-' + idx)" style="
                            white-space: pre-wrap;
                            word-break: break-word;
                            cursor: pointer;
                          ">
                          {{ i.description }}
                        </span>
                      </template>
                      <template v-else>
                        <span class="desc-truncated" @click="toggleDescription(row.id + '-' + idx)"
                          style="cursor: pointer" :title="i.description">
                          {{ truncate(i.description, 20) }}
                        </span>
                      </template>
                    </div>
                  </div>
                </template>

                <template #cell(batch)="{ row }">
                  <div v-if="GeneralSettings.track_expiries == 1">
                    <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                      {{ i.batch }}
                    </div>
                  </div>
                </template>

                <template #cell(totalAmt)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <template #cell(amt_paid)="{ row, value }">
                  <span class="text-warning" style="cursor: pointer" v-b-modal.expired-modal @click="ShowEdit(row)"
                    v-if="row.numpaid < 2">
                    {{ thousandSeperator(value) }}
                  </span>
                  <span v-else>
                    {{ thousandSeperator(value) }}
                  </span>
                </template>

                <template #cell(discount_field)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <template #cell(customerobj)="{ row }">
                  {{ row.customerobj?.name || "N/A" }}
                </template>

                <template #cell(user)="{ value }">
                  {{ value }}
                </template>

                <template #cell(date)="{ value }">
                  {{ value }}
                </template>

                <template #cell(addedon)="{ value }">
                  {{ value }}
                </template>

                <template #cell(receipt)="{ value }">
                  {{ value }}
                </template>

                <template #cell(actions)="{ row }">
                  <b-dropdown text="More Actions..." size="sm" class="btn-primary" v-if="MyUserPerm.modify_sales == 1">
                    <b-dropdown-item v-if="MyUserPerm.delete_sales == 1" v-b-modal.delete-sale-modal
                      @click="showDeleteModal({ item: row })">
                      <i class="fa fa-trash text-danger"></i>
                      <span class="text-danger"> Delete</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="MyUserPerm.edit_sales == 1" v-b-modal.edit-sale-modal
                      @click="showEditModal({ item: row })">
                      <i class="fa fa-edit text-primary"></i>
                      <span class="text-primary"> Edit</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="Receipt_print(row.id)">
                      <i class="fa fa-download"></i> Reprint
                    </b-dropdown-item>
                    <b-dropdown-item v-if="row.totalAmt > row.totalPaid" v-b-modal.generate-invoice-modal
                      @click="showInvoiceModal({ item: row })">
                      <i class="fa fa-file-invoice text-success"></i>
                      <span class="text-success"> New Invoice</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ReceiptSettings.print_deliverynotes" v-b-modal.reprint-modal
                      @click="setID(row.id)">
                      <i class="fa fa-eye text-secondary"></i>
                      <span class="text-success"> View</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showReceipt(row.id)">
                      <i class="fa fa-eye text-secondary"></i>
                      <span class="text-success"> View</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </DataTable>

              <div class="row">
                <div class="col-md-3">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Paid:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalPaid)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Discount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalDiscount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Balance:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalBalance)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                      aria-controls="tickets-table"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- resynchronise mode starts -->
    <b-modal header-bg-variant="info" header-text-variant="light" body-text-variant="info" footer-bg-variant="info"
      footer-text-variant="info" id="sale-submit-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Resubmit This Sale</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            You are submitting this sale to URA? Click Proceed Button to Submit
            the Sale.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('sale-submit-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled>
          <i class="fa fa-check"></i> Proceed
          <b-spinner variant="light" small label="Submitting"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="submitSale('sale-submit-modal')">
          <i class="fa fa-check"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- resynchronise mode ends -->
    <!-- modal mark as expired starts -->
    <b-modal id="expired-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">
          Edit Amount Paid For a Sale of
          {{ thousandSeperator(editAmtData.total) }}
        </h4>
      </template>
      <label>Amount Paid</label>
      <div class="input-group">
        <input type="text" class="form-control" v-model="editAmtData.paid" placeholder="Enter actual amount"
          @input="resetError(), addCommas()" />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('expired-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-warning" disabled>
          <i class="fa fa-minus"></i> Confirm
          <b-spinner variant="light" small label="Submiting"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-warning" @click="editAmt('expired-modal')">
          <i class="fa fa-minus"></i> Confirm
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal header-bg-variant="warning" header-text-variant="light" body-text-variant="warning"
      footer-bg-variant="warning" footer-text-variant="warning" id="edit-sale-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit This Sale</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to return and edit this Sale? Click Proceed Button to
            Return Sale for Editing.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('edit-sale-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled>
          <i class="fa fa-edit"></i> Proceed
          <b-spinner variant="light" small label="Deleting"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="editSale('edit-sale-modal')">
          <i class="fa fa-edit"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
      footer-bg-variant="danger" footer-text-variant="danger" id="delete-sale-modal" hide-footer @hidden="resetDelete">
      <template #modal-title> Delete This Sale</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>
            Do you want to delete this Sale? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('delete-sale-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-danger">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner variant="light" small label="Deleting"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-danger" @click="deleteSale('delete-sale-modal')">
          <i class="fa fa-trash"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- Invoice modal starts -->
    <b-modal header-bg-variant="success" header-text-variant="light" body-text-variant="success"
      footer-bg-variant="success" footer-text-variant="success" id="generate-invoice-modal" hide-footer
      @hidden="resetGenerate">
      <template #modal-title> Generate invoice</template>
      <div class="form-group mb-2">
        <div class="input-group">
          <h5>Click Proceed Button to generate an invoice for this sale.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          @click="closeModal('generate-invoice-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-success" disabled>
          <i class="fa fa-edit"></i> Proceed
          <b-spinner variant="light" small label="Deleting"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-success" @click="GenerateInvoice('generate-invoice-modal')">
          <i class="fa fa-edit"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- Invoice modal ends -->

    <!--SALES EXCEL UPLOAD MODAL-->
    <b-modal id="import-sales-modal" ref="modal" hide-footer title="Import Sales from Excel" @hidden="file = null">
      <template #modal-title> Import Sales from Excel </template>
      <template>
        <ExcelImport :template-fields="excelTemplateFields" template-filename="sales_import_template.xlsx"
          upload-label="Select Excel file with sales data:" import-url="import_sales"
          :required-headers="excelRequiredHeaders" :custom-validation="validateSalesData"
          @import-success="handleExcelImportSuccess" @import-error="handleExcelImportError"
          @close-modal="closeModal('import-sales-modal')" />
      </template>
    </b-modal>
    <!-- SALES EXCEL UPLOAD END -->

    <!-- modal share invoice via WhatsApp -->
    <b-modal header-bg-variant="info" header-text-variant="light" body-text-variant="info" footer-bg-variant="info"
      footer-text-variant="info" id="reprint-modal" hide-footer>
      <template #modal-title> Reprint Receipt </template>
      <div class="modal-content">
        <div class="modal-body">
          <p class="mb-0 font-size-16">How would you like to reprint?</p>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button type="button" class="btn btn-info" @click="showReceipt(id)">
            Receipt
          </button>
          <button type="button" class="btn btn-secondary" @click="showDeliverynote(id)">
            Delivery Note
          </button>
        </div>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

.sales-table-bordered td {
  border-bottom: 1px solid #000 !important;
}
</style>
